// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"27bc6bec","885":"f732c3bc"}[chunkId] + ".chunk.js";
};